import { styled } from "@mui/material/styles";
import { useColors } from "../../Context/ColorsContext"
import { BaseCard, MediaQuerys } from "../../styles/GlobalStyle";

const { mobile, desktop } = MediaQuerys;

export const SectionPageTitle = styled("section")(() => ({
  display: "flex",
  width: "100%",
}));

export const FormContainer = styled(BaseCard)(() => {
  const { colors } = useColors();  
  return {
    background: colors.white,
    padding: 20,
    marginTop: '10px',
  }
});

export const Title = styled('h1')(() => ({
  fontWeight: 'bold',
  fontSize: 14,
  [desktop]: {
    fontSize: '1rem'
  },
  [mobile]: {
    fontSize: '0.75rem'
  }
}));

export const Text = styled('p')(() => ({
  fontSize: 14,
  [desktop]: {
    fontSize: '0.85rem'
  },
  [mobile]: {
    fontSize: '0.75rem'
  }
}));

export const ContainerContent = styled('div')(({ theme }) => {
  return {
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
    marginBottom: '10px',
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
    }
  }
})

export const ContainerTitle = styled('div')(({ theme }) => {
  return {
    display: 'flex',
    alignItems: 'flex-start',
    flexDirection: 'column',
    width: '33%',
    [theme.breakpoints.down('md')]: {
      width: '100%',
      marginBottom: '14px',
    }
  }
})

